import React, { useState } from "react"
import { NavLink } from "react-router-dom"

import * as Icons from "../../../assets/icons"

const MenuItem = ({ name, url, submenu }) => {
  const [expanded, setExpanded] = useState(false)
  const hasSubmenu = submenu.length !== 0

  return (
    <li className={`nav-item ${hasSubmenu ? "has-submenu" : ""} ${expanded ? "expanded" : ""}`}>
      <div className="nav-item-row">
        <NavLink to={url} exact className="nav-link" activeClassName="active">
          {name}
        </NavLink>
        {hasSubmenu && (
          <button
            type="button"
            className="nav-expand"
            onClick={() => setExpanded(!expanded)}
            aria-expanded={expanded}
            aria-label={`Rozwiń: ${name}`}
          >
            <Icons.ExpandMore />
          </button>
        )}
      </div>
      {hasSubmenu && (
        <ul className="submenu">
          {submenu.map((subItem) => (
            <li key={subItem.id}>
              <NavLink to={subItem.url} exact className="submenu-link" activeClassName="active">
                {subItem.name}
              </NavLink>
            </li>
          ))}
        </ul>
      )}
    </li>
  )
}

export default MenuItem
